export default "__VITE_ASSET__DNiZLvVy__"